import React, { useState } from 'react'
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom'
import { routes } from '../config/routes.config'
import { useAuthStore } from '../stores/useAuthStore'
import clsx from 'clsx'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

export const AdminLayout: React.FC = () => {
  const location = useLocation()
  const { isAuthenticated, logout } = useAuthStore()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="flex h-screen bg-gray-100">
      {/* 移动端遮罩层 */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* 侧边栏 - 移动端 */}
      <div className={`
        fixed inset-y-0 left-0 z-30
        w-64 bg-white shadow-lg transform 
        lg:relative lg:translate-x-0 transition-transform duration-200 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex items-center justify-between p-4">
          <h1 className="text-xl font-bold text-gray-800">管理后台</h1>
          <button 
            className="lg:hidden"
            onClick={() => setSidebarOpen(false)}
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>
        
        {/* 原有的导航内容 */}
        <nav className="mt-4">
          {routes.map((route) => {
            const Icon = route.icon
            return (
              <Link
                key={route.path}
                to={route.path}
                className={clsx(
                  'flex items-center px-4 py-2 text-gray-600 hover:bg-gray-50',
                  location.pathname === route.path && 'bg-primary-50 text-primary-600'
                )}
              >
                <Icon aria-hidden="true" className="w-5 h-5 mr-2" />
                <span>{route.name}</span>
              </Link>
            )
          })}
        </nav>
      </div>

      {/* 主内容区 */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white shadow-sm">
          <div className="px-4 py-4 flex justify-between items-center">
            {/* 添加移动端菜单按钮 */}
            <button
              className="lg:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <Bars3Icon className="h-6 w-6 text-gray-600" />
            </button>

            <h2 className="text-lg font-semibold text-gray-900">
              {routes.find(route => route.path === location.pathname)?.name || '仪表盘'}
            </h2>
            
            <button
              onClick={logout}
              className="px-4 py-2 text-sm text-red-600 hover:text-red-700"
            >
              退出登录
            </button>
          </div>
        </header>
        
        <main className="flex-1 overflow-auto p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
} 